export const HUB_FIELD_ID_TEXT = {
    id: 'oe.label.fieldId',
    defaultMessage: 'Field ID',
    description: 'Field ID label'
};

export const HUB_FIELD_LABEL_TEXT = {
    id: 'oe.label.fieldLabel',
    defaultMessage: 'Field Label',
    description: 'Label text'
};

export const HUB_FIELD_TYPE_TEXT = {
    id: 'oe.label.fieldType',
    defaultMessage: 'Field Type',
    description: 'Field type label'
};

export const HUB_FIELD_OPTIONS_TEXT = {
    id: 'oe.label.fieldOptions',
    defaultMessage: 'Options',
    description: 'Field options label'
};

export const HUB_CUSTOM_FIELD_ID_ALREADY_EXISTS_TEXT = {
    id: 'oe.hub.customFieldIdAlreadyExists',
    defaultMessage: 'Field ID already exists',
    description: 'Warning message'
};
